import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Grid,
  TextField,
  Pagination,
} from "@mui/material";
import { SimpleCard } from "app/components";
import { DeleteOutline, Restore , Visibility} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Loading from "app/components/MatxLoading";
import Avatar from "react-avatar";
import { PAGE_LIMIT } from "../../../config";
import { StyledTable } from "app/assets";

import { toast } from 'react-toastify';
import { GETALLUSERS, REMOVEUSER, RESTOREUSER } from "app/redux/actions";
import styled from "styled-components";

const DeletedEmployees = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const loggedInUser = useSelector((state) => state.user.user);

  const user = useSelector((state) => state.user)
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
const handleView = (employeeId) => {
    navigate(`/view-employee/${employeeId}`); 
  };
  useEffect(() => {
    if (loggedInUser?.token) {
      dispatch(
        GETALLUSERS(
          {
            page: page,
            limit: PAGE_LIMIT,
            searchValue: searchValue,
            isDeleted: true
          },
          loggedInUser
        )
      );
    }
  }, [dispatch, loggedInUser, page, searchValue]);



  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleSearch = () => {
    setPage(1);
  };

  const onSuccess = (message) => {
    toast.success(message);
  };
  const onFail = (message) => {
    toast.error(message);
  };
  const handleDeleteClick = (id) => {
    setEmployeeToDelete(id);
    setDialogOpen(true);
  };

  const confirmDelete = () => {
    dispatch(REMOVEUSER({ permanent: true }, employeeToDelete, loggedInUser, onSuccess, onFail));
    setDialogOpen(false);
    setEmployeeToDelete(null);
  };

  const handleEdit = (employeeId) => {
    dispatch(RESTOREUSER(employeeId, loggedInUser, onSuccess, onFail));
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEmployeeToDelete(null);
  };
  const TableContainer = styled.div`
    overflow-x: auto;
  
    @media (max-width: 600px) {
    width: 150%;
      border: 1px solid #e0e0e0;
    }
  `;
  return (
    <SimpleCard>

      <Grid container spacing={2} sx={{ my: 2 }}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Search by Name"
            variant="outlined"
            size="small"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSearch()}
          />
        </Grid>
      </Grid>

      {user.allUsersLoading === true ? (
        <Loading />
      ) : (
        <>
          <Box sx={{ flexGrow: 1, overflow: 'auto', paddingBottom: '70px' }}>
            <TableContainer>
              <StyledTable>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Profile</TableCell>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="center">Joining Date</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Role</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    (!user?.allUsers?.users || (user?.allUsers?.users || []).length > 0 ?
                      (user?.allUsers?.users || []).map((user) => (
                        <TableRow key={user.id}>
                          <TableCell align="center">
                            <Avatar
                              size="40"
                              round={true}
                              name={user.name}
                              src={user.avatar}
                            />
                          </TableCell>
                          <TableCell align="left">{user.name}</TableCell>
                          <TableCell align="left">{user.email}</TableCell>
                          <TableCell align="center">
                            {new Date(user.joiningDate).toLocaleDateString()}
                          </TableCell>
                          <TableCell align="center">{user.status}</TableCell>
                          <TableCell align="center">{user.userType}</TableCell>
                          <TableCell align="center">
                            <IconButton onClick={() => handleView(user.id)} color="primary">
                                                          <Visibility />
                                                        </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                      :
                      <TableCell colSpan={6} align="center">
                        No Employees Found
                      </TableCell>
                    )
                  }
                </TableBody>
              </StyledTable>
            </TableContainer>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            sx={{
              position: 'sticky',
              bottom: 0,
              py: 2,
              backgroundColor: 'background.paper',
              zIndex: 1,
              boxShadow: '0 -2px 5px rgba(0,0,0,0.1)'
            }}
          >
            <Pagination
              count={user?.allUsers?.totalPages || 1}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        </>


      )}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this employee?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </SimpleCard>
  );
};

export default DeletedEmployees;